"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateConversationTitleOutputDtoSchema = exports.generateConversationTitleInputDtoSchema = void 0;
const zod_1 = require("zod");
const conversation_summary_dto_js_1 = require("./conversation-summary.dto.js");
exports.generateConversationTitleInputDtoSchema = zod_1.z.object({
    conversationId: conversation_summary_dto_js_1.agentChatConversationIdSchema,
});
exports.generateConversationTitleOutputDtoSchema = zod_1.z.object({
    title: zod_1.z.string(),
});
//# sourceMappingURL=generate-conversation-title.dto.js.map